import { Expose } from 'class-transformer';

export default class ScoreHistoryModel {
    @Expose()
    scoreHistory!: {
        [date: string]: number | null
    };
}
